export { countAbgeschlosseneAufgaben, countAllOffenOrAbgeschlosseneAufgaben, countOffeneAufgaben } from '../../core/application/count-aufgaben';
export { getErgebnisoptionen, validAufgabeErgebnisValues } from '../../core/application/ergebnis-optionen';
export type { AufgabeErgebnis } from '../../core/application/ergebnis-optionen';
export { hasAusstattung } from '../../core/application/objekt-ausstattung';
export { useAufgabe } from './aufgabe';
export { useAufgabeAbschliessen } from './aufgabe-abschliessen';
export { useAufgabeZwischenergebnisErfassen } from './aufgabe-zwischenergebnis-erfassen';
export { useAufgabeErstellenMutation } from './AufgabeErstellenMutation';
export { useBearbeiterQuery } from './BearbeiterQuery';
export { useObjekt } from './objekt';
export { useObjektAufgabenStatistik } from './objekt-aufgaben-statistik';
export { useObjekte } from './objekte';
export { useVerfuegbareObjekteQuery } from './VerfuegbareObjekteQuery';
export { clientVersionVar, useVersions } from './versions';

